<template>
  <div class="share">
    <transition name="xz-fade">
      <div class="mask" v-if="isVisible" @click="toggle"></div>
    </transition>
    <transition name="xz-slide-up" @touchmove.stop.prevent>
      <div class="panel" v-if="isVisible">
        <div class="box">
          <div class="share_title">分享到</div>
          <div class="content">
            <div class="item" :key="index" v-for="(share, index) in shares">
              <span
                :class="share.type"
                class="icon iconfont"
                v-html="share.icon"
                @click="goShare(share.type, '', '', '', '', '', shareData)"
              >
              </span>
              <p class="txt">
                {{ share.text }}
              </p>
            </div>
          </div>
        </div>
        <span class="cancel_btn" @click="toggle">
          取消
        </span>
      </div>
    </transition>
    <transition name="xz-slide-up" @touchmove.stop.prevent>
      <div class="panel">
        <div class="mask" v-if="isShowAppMask" @click="toggleAppMask"></div>
        <div class="appShareImg" v-if="isShowAppMask">
          <img
            src="../../static/images/app_share_img.png"
            alt=""
            v-if="appSahre"
          />
          <img
            src="../../static/images/rightTopShareImg.png"
            alt=""
            v-if="topShare"
          />
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
// import { apiUrl, imroot } from '../../config/env'
import { Toast, Indicator } from "mint-ui";
import getUa from "../../utils/getUa";
export default {
  data() {
    return {
      isVisible: false,
      isShowAppMask: false,
      appSahre: false,
      topShare: true,
      shareInvite: "",
      shares: [
        {
          type: "qq",
          text: "QQ",
          icon: "&#xe820;"
        },
        {
          type: "weixin",
          text: "微信",
          icon: "&#xe81c;"
        },
        {
          type: "friendcircle",
          text: "朋友圈",
          icon: "&#xe81e;"
        },
        {
          type: "sinaweibo",
          text: "微博",
          icon: "&#xe81f;"
        },
        {
          type: "qqzone",
          text: "qq空间",
          icon: "&#xe81d;"
        }
      ],
      myShare: ["sinaweibo", "qqzone"],
      state: getUa.userAgent
    };
  },
  props: {
    shareData: Object
  },
  methods: {
    toggle(datas) {
      this.isVisible = !this.isVisible;
      this.showShares(datas);
    },
    toggleAppMask() {
      this.isShowAppMask = !this.isShowAppMask;
    },
    showShares(data) {
      this.simpleShareV2("", "", "", "", "", data);
    },
    goShare(
      shareType,
      shareUrl,
      shareContent,
      shareTitle,
      shareDesc,
      shareImg,
      shareDatas
    ) {
      if (this.state.iswechat) {
        this.isVisible = false;
        this.isShowAppMask = true;
        this.topShare = true;
        this.appSahre = false;
      } else if (
        this.myShare.indexOf(shareType) < 0 &&
        (this.state.isqq || this.state.iswebo)
      ) {
        this.isVisible = false;
        this.isShowAppMask = true;
        this.topShare = true;
        this.appSahre = false;
      } else if (this.myShare.indexOf(shareType) < 0) {
        this.isVisible = false;
        this.isShowAppMask = true;
        this.appSahre = true;
        this.topShare = false;
      } else {
        if (!shareDatas) {
          this.simpleShareV1(
            shareType,
            shareUrl,
            shareContent,
            shareTitle,
            shareDesc,
            shareImg
          );
        } else {
          shareDatas.channel = shareType;
          this.shareContent(
            shareType,
            shareDatas.action,
            shareDatas.objId,
            shareDatas.shareInvite
          );
        }
      }
    },
    setWechatDefalutShare(id, actions) {
      if (!this.state.iswechat || !id || !actions) {
        return false;
      }
      this.shareContent("weixin", actions, id, "no");
    },
    setWechatShare(title, url, shareContent, imageUrl) {
      if (typeof wx === "undefined") return false;
      if (imageUrl.indexOf("https") < 0) {
        imageUrl = "https:" + imageUrl;
      }
      const shareUrl = location.href.split("#")[0];
      let shareLink = "";
      if (this.shareData.action == "detail") {
        if (shareUrl.indexOf("?") > 0) {
          shareLink = `${location.href.split("#")[0]}&shareId=${
            this.shareData.objId
          }`;
        } else {
          shareLink = `${location.href.split("#")[0]}?shareId=${
            this.shareData.objId
          }`;
        }
      } else {
        if (shareUrl.indexOf("?") > 0) {
          shareLink = `${location.href.split("#")[0]}&shareId=''`;
        } else {
          shareLink = `${location.href.split("#")[0]}?shareId=''`;
        }
      }
      const shareConf = {
        title: title,
        link: shareLink,
        desc: shareContent,
        dataUrl: "",
        imgUrl: imageUrl,
        success: function() {}
      };
      wx.ready(function() {
        wx.onMenuShareTimeline(shareConf);
        wx.onMenuShareQQ(shareConf);
        wx.onMenuShareAppMessage(shareConf);
        wx.onMenuShareQZone(shareConf);
      });
    },
    simpleShareV1(
      shareTypes,
      shareUrls,
      shareContents,
      title,
      desc,
      image,
      site
    ) {
      const that = this;
      const shareParams = {
        channel: shareTypes,
        shareUrl: shareUrls,
        shareContent: shareContents,
        title: title,
        desc: desc,
        image: image,
        site: site
      };
      Indicator.open();
      this.$get(apiUrl + "global/simpleShare", shareParams).then(res => {
        Indicator.close();
        if (res.status != 200) {
          Toast(res.errorMsg);
          return false;
        } else {
          window.location.href = res.content;
        }
      });
    },
    shareContent(type, actions, id, shareInvite) {
      const that = this;
      const params = {
        channel: type,
        objId: id,
        action: actions,
        shareInvite: shareInvite
      };
      Indicator.open();
      that.$get(apiUrl + "global/ShareContent", params).then(res => {
        Indicator.close();
        if (res.status !== 200) {
          Toast(res.errorMsg);
          return false;
        } else {
          const content = res.content;
          if (content.imageUrl.indexOf("https") < 0) {
            content.imageUrl = "https:" + content.imageUrl;
          }
          if (type === "weixin" && this.state.iswechat) {
            // 微信分享
            this.setWechatShare(
              content.title,
              content.url,
              content.shareContent,
              content.imageUrl
            );
          } else {
            this.simpleShareV1(
              type,
              content.url,
              content.shareContent,
              content.title,
              content.desc,
              content.imageUrl,
              content.url
            );
          }
        }
      });
    },
    simpleShareV2(shareUrls, shareContents, title, desc, imgs, shareData) {
      if (imgs.indexOf("https") < 0) {
        const images = "https" + imgs;
      }
      if (shareData) {
        this.shareInvite = shareData.shareInvite;
      }
      if (this.state.isxzapp) {
        this.webView.setShare(
          shareUrls,
          shareContents,
          title,
          desc,
          imgs,
          shareUrls,
          imgs,
          "",
          shareData
        );
        this.webView.openShare();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.share {
  .mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 102;
    background: rgba(0, 0, 0, 0.5);
  }
  .panel {
    position: fixed;
    bottom: 20px;
    left: 0;
    z-index: 103;
    width: 100%;
  }
  .appShareImg {
    width: 60%;
    position: fixed;
    top: 13%;
    left: 50%;
    transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    z-index: 1002;
    img {
      width: 100%;
    }
  }
  .box {
    margin: 0 15px;
    border-radius: 6px;
    background: #fff;
  }
  .share_title {
    padding: 18px 0 15px;
    color: #323232;
    font-size: 14px;
    text-align: center;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 20px;
    font-size: 14px;
    .item {
      margin-top: 20px;
      flex: 0 0 33.3%;
      text-align: center;
    }
    .icon {
      display: inline-block;
      width: 46px;
      height: 46px;
      line-height: 46px;
      color: red;
      text-align: center;
      border: 0.266vw solid #000;
      border-radius: 50%;
      font-size: 24px;
      &.qq {
        color: #4983f9;
        border-color: #4983f9;
      }
      &.weixin {
        color: #8ad260;
        border-color: #8ad260;
      }
      &.friendcircle {
        color: #73d18e;
        border-color: #73d18e;
      }
      &.sinaweibo {
        color: #ed635b;
        border-color: #ed635b;
      }
      &.qqzone {
        color: #f0c52c;
        border-color: #f0c52c;
      }
    }
    .txt {
      margin-top: 10px;
    }
  }
  .cancel_btn {
    display: block;
    margin: 10px 15px 0;
    height: 45px;
    line-height: 45px;
    color: #323232;
    font-size: 16px;
    text-align: center;
    border-radius: 6px;
    background: #fff;
  }
  .xz-fade-enter-active,
  .xz-fade-leave-active {
    transition: opacity 0.3s;
  }
  .xz-fade-enter,
  .xz-fade-leave-to {
    opacity: 0;
  }
  .xz-slide-up-enter-active,
  .xz-slide-up-leave-active {
    transition: transform 0.3s ease;
  }
  .xz-slide-up-enter,
  .xz-slide-up-leave-to {
    transform: translate(0, 320px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/share.vue